import { render, staticRenderFns } from "./openWorkorder.vue?vue&type=template&id=7a15db00"
import script from "./openWorkorder.vue?vue&type=script&lang=js"
export * from "./openWorkorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a15db00')) {
      api.createRecord('7a15db00', component.options)
    } else {
      api.reload('7a15db00', component.options)
    }
    module.hot.accept("./openWorkorder.vue?vue&type=template&id=7a15db00", function () {
      api.rerender('7a15db00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/workorder/openWorkorder.vue"
export default component.exports